import { render, staticRenderFns } from "./VodEventSetting.vue?vue&type=template&id=95e77b76&"
import script from "./VodEventSetting.vue?vue&type=script&lang=js&"
export * from "./VodEventSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTextField,VTooltip})
